import { green, red } from '@mui/material/colors';
import { FunctionField, RaRecord } from 'react-admin';
import { ColorChip } from 'shared/mui/Chips/ColorChip/ColorChip';

export type BooleanStatusChipFieldProps = {
  enabledLabel: string;
  disabledLabel: string;
  enabledColor?: string;
  disabledColor?: string;
  source: string;
};

export const BooleanStatusChipField: React.FC<BooleanStatusChipFieldProps> = ({
  enabledLabel,
  disabledLabel,
  enabledColor = green[500],
  disabledColor = red[500],
  source,
}) => {
  return (
    <FunctionField
      render={(record: RaRecord) => {
        if (!(source in record)) {
          return <></>;
        }
        const isEnabled = record[source];
        return (
          <ColorChip
            iconColor={isEnabled ? enabledColor : disabledColor}
            iconSize="l"
            label={isEnabled ? enabledLabel : disabledLabel}
            size="small"
          />
        );
      }}
    />
  );
};
